
import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
// import vuetify from './plugins/vuetify';
import vuetify from '_shared/styles/vuetify';

import _i18n, { i18n } from '_shared/i18n'
import account from '_shared/account'

import notification from '_shared/notification'
import userwatcher from '_shared/userWatcher'

import '_shared/styles/main.css'
import '@mdi/font/css/materialdesignicons.css'


Vue.config.productionTip = false

Vue.use(_i18n, store)

Vue.use(account, {
  store, router, mgr: {
    client_id: "webapp.client",
    scope: "openid profile api role",
  }
})

Vue.use(notification, store)
Vue.use(userwatcher, store)

///TODO 
export const hubs = {
  async StartAll() {
    await window.notification.start();
    await window.userwatcher.start();
  }
};

window.account.init();

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')












